import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotFound from "components/NotFound";
import Online from "./online";
import Offline from "./offline";


const mapStateToProps = state => ({
    ...state.cooperationer,
});

const mapDispatchToProps = dispatch => ({});

class Cooperation extends React.Component {
    render() {
        const { match } = this.props;
        const basepath = match.path === "/" ? "" : match.path;
        return (
            <Switch>
                <Route exact path={`${basepath}/online`} component={Online} />
                <Route exact path={`${basepath}/offline`} component={Offline} />
                <Route exact component={NotFound} />
            </Switch>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Cooperation);